module.exports = __webpack_public_path__ + "images/category_lp/watch/omega/assessment_achievements/2_8f78c8a97057f0471224442c7f2b3abd.png";